import { useMemo } from "react";

export type Config = {
  VERIFICATION_PORTAL_BASE_URL: string;
  MYSGI_URL: string;
  SGI_RESET_PASSWORD_URL: string;
  SGI_REGISTRATION_URL: string;
  SGI_SUPPORT_URL: string;
}

export type WindowWithConfig = typeof window & { runConfig?: Config }

const defaultConfig: Config = {
  VERIFICATION_PORTAL_BASE_URL: "",
  MYSGI_URL: "",
  SGI_RESET_PASSWORD_URL: "",
  SGI_REGISTRATION_URL: "",
  SGI_SUPPORT_URL: ""
};

export const useConfig = () => {
  const runConfig = (window as WindowWithConfig).runConfig;
  return useMemo(() => runConfig ?? defaultConfig, [runConfig]);
}